var angular = require('angular');
var _module = angular.module('benoit');

require('angular-material');
require('angular-input-masks');

_module.requires.push(
    'ngMaterial',
    'ui.utils.masks'
);

_module.component('contactagentloForm', {
    controllerAs: 'vm',
    controller: [
        '$mdMedia',

        function ($mdMedia) {
            var vm = this;
            vm.services = {
                $mdMedia: $mdMedia
            };
            vm.events = {
                onSubmit: function ($form) {
                    vm.onSubmit({ $form: $form });
                }
            };
        }
    ],
    template: require('./index.html'),
    bindings: {
        ngModel: '=',
        onSubmit: '&'
    }
});
